import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { IVendorsStatistics } from '../../PayablesTab/Store/VendorsStore'
import { useTranslation } from 'react-i18next'
import { currencyMask } from '../../../../utils/helpers/masking'
import { observer } from 'mobx-react-lite'

interface CompanyStatisticsProps {
  statistics: IVendorsStatistics
}
interface SingleRowProps {
  label: string
  value: string | number
}
const SingleRow: React.FC<SingleRowProps> = ({ label, value }) => (
  <View style={styles.row}>
    <Text style={styles.label}>{label}</Text>
    <Text style={styles.value}>{value}</Text>
  </View>
)

const CompanyStatistics: React.FC<CompanyStatisticsProps> = observer(
  ({ statistics }) => {
    const { t } = useTranslation('payables')
    const { totalDueInvoices, availableCredit, creditLimit, totalDueSum } =
      statistics

    const fields = [
      {
        label: t('payables.header.totalBalanceDue'),
        value: currencyMask(totalDueSum),
      },
      {
        label: t('payables.header.availableCredit'),
        value: currencyMask(availableCredit),
      },
      {
        label: t('payables.header.inHouseCreditLimit'),
        value: currencyMask(creditLimit),
      },
      {
        label: t('payables.header.numberOfDueInvoices'),
        value: totalDueInvoices,
      },
    ]
    return (
      <View style={styles.container}>
        {fields.map((field, index) => (
          <SingleRow key={index} label={field.label} value={field.value} />
        ))}
      </View>
    )
  },
)

const styles = StyleSheet.create({
  container: {
    paddingBottom: 16,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#E6EBEE',
    paddingVertical: 14,
  },
  label: {
    fontSize: 14,
    color: '#99ADBA',
    lineHeight: 21,
    fontWeight: '500',
    fontFamily: 'Inter',
  },
  value: {
    fontSize: 14,
    lineHeight: 21,
    color: '#335C75',
    fontWeight: '700',
    fontFamily: 'Inter',
  },
})

export default CompanyStatistics
